'use client';

import { Button } from '@ahafood/ui/components/button';
import { Card } from '@ahafood/ui/components/card';
import { Image } from '@ahafood/ui/components/image';
import React from 'react';

interface ChatGreetingCardProps {
  userName?: string;
  onSuggestionClick: (suggestion: string) => void;
  isLoading?: boolean;
}

export function ChatGreetingCard({
  userName,
  onSuggestionClick,
  isLoading = false,
}: ChatGreetingCardProps) {
  const displayName =
    userName && userName !== 'Ahamove User' ? userName : 'Bạn';

  return (
    <Card className="flex flex-col items-center gap-2 bg-gradient-to-b from-white via-white to-red-20/60 rounded-xl mt-6 py-6 px-4 border-none shadow-md justify-center relative overflow-y-visible pt-10">
      <div className="absolute top-3 right-3">
        <Image
          src="/static/images/ai-icon.png"
          alt="Chatbot Detail"
          width={33}
          height={24}
        />
      </div>
      <div className="flex">
        <div className="relative size-20 flex-none">
          <Image
            src="/static/images/chatbot-detail.webp"
            alt="AI Bot"
            fill
            className="object-contain"
          />
        </div>
        <div className="">
          <div className="flex text-xs items-center font-medium bg-gradient-to-b from-primary-50 via-[#a82200] to-secondary-50 bg-clip-text text-transparent w-fit">
            Một mình? Có Amori! Một bữa có{' '}
            <Image
              width={71}
              height={21}
              className="ml-1"
              src={'/static/images/solo-meal.png'}
              alt={'Solo Meal'}
            />
          </div>
          <div className="text-2xl font-bold mt-1 bg-gradient-to-r from-[#A80036] via-red-40 to-secondary-50 bg-clip-text text-transparent w-fit">
            {displayName} muốn ăn gì?
          </div>
        </div>
      </div>
      <div className="flex w-full justify-start gap-2 font-normal">
        <Button
          variant="outline"
          onClick={() => onSuggestionClick('Solo Meal')}
          disabled={isLoading}
          className="bg-white/30 border-2 border-white w-full px-2 rounded-lg hover:bg-white/50 font-light"
          style={{ whiteSpace: 'nowrap' }}
        >
          Solo Meal
        </Button>
        <Button
          variant="outline"
          onClick={() => onSuggestionClick('Món có deal')}
          disabled={isLoading}
          className="bg-white/30 border-2 border-white w-full px-2 rounded-lg hover:bg-white/50 font-light"
          style={{ whiteSpace: 'nowrap' }}
        >
          Món có deal 🔥
        </Button>
        <Button
          variant="outline"
          onClick={() => onSuggestionClick('Món ngẫu nhiên')}
          disabled={isLoading}
          className="bg-white/30 border-2 border-white w-full px-2 rounded-lg hover:bg-white/50 font-light"
          style={{ whiteSpace: 'nowrap' }}
        >
          Món ngẫu nhiên
        </Button>
      </div>
    </Card>
  );
}
